import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    clientname: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' }, ,
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' }
      ]
    }, 
    notes: {
      validations: [
        { type: 'required', message: 'Please complete this required field.' }
      ]
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Name',
            mapping: 'clientname',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address',
            mapping: 'email',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telNumber',
            customClasses: ['no-label']
      },
      {
            type: 'multiple-choice-nolabel',
            size: 'Medium',
            label: 'How did you hear about us?',
            options: [
              { label: 'Facebook' , value: 'Facebook'},
              { label: 'Instagram', value: 'Instagram'},
              { label: 'Yelp', value: 'Yelp'},
              { label: 'Newday', value: 'Newday' },
              { label: 'Tri-State Restaurant Club' , value: 'Tri-State Restaurant Club'},
              { label: 'Friend', value: 'Friend'},
              { label: 'Patron', value: 'Patron'}
            ],
            mapping: 'reference',
            customClasses: ['no-label']
          }
        ]
      },   
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Message',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Vienna of Roslyn Contact Us Form',
    formId: '354',
    clientKey: '556959E7-4F59-4437-AC6D-4741A0C047D6',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://viennaofroslyn.com/thank-you/',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
